// May only be used as a singleton
import tones from './riffWave';

let _instance;
// var onPlaying = false;
// var onPause = true;

class DTMFGenerator {
  constructor(dtmfOutputDeviceId) {
    this.displayName = 'DTMFGenerator';
    this._dtmfOutputDeviceId = dtmfOutputDeviceId;
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    this.setDTMFOutputDevice = this.setDTMFOutputDevice.bind(this);

    this.setDTMFOutputDevice(this._dtmfOutputDeviceId);

    this.audioElements = {};
    this.setupAudioElements();

    if (this._dtmfOutputDeviceId) {
      Object.keys(this.audioElements).forEach((element) => {
        this.audioElements[element].setSinkId(this._dtmfOutputDeviceId);
      });
    }
  }
  setupAudioElements() {
    // For each 'tone', set up and audio element.
    Object.keys(tones).forEach((tone) => {
      this.audioElements[tone] = new Audio();
      this.audioElements[tone].src = tones[tone];
      this.audioElements[tone].volume = 0.09;
      this.audioElements[tone].loop = true;
    });
  }

  setDTMFOutputDevice(id) {
    this._dtmfOutputDeviceId = id;
    if (this.audioElements && this._dtmfOutputDeviceId) {
      Object.keys(this.audioElements).forEach((element) => {
        this.audioElements[element].setSinkId(this._dtmfOutputDeviceId);
      });
    }
  }

  getAudioElementForChar(character) {
    var audioElemIndexForChar = Object.keys(this.audioElements).reduce(function (p, c) {
      if (p) {
        return p;
      }
      if (c.indexOf(character) > -1) {
        return c;
      }
      return p;
    }, undefined);
    return this.audioElements[audioElemIndexForChar];
  }

  play(character) {
    // console.log('pppppp', character)
    this.getAudioElementForChar(character).play();
  }

  stop(character) {
    // console.log('stop charactor', character);
    this.getAudioElementForChar(character).pause();
  }

  static getInstance(dtmfOutputDeviceId) {
    if (!_instance) {
      _instance = new DTMFGenerator(dtmfOutputDeviceId);
    } else {
      _instance.setDTMFOutputDevice(dtmfOutputDeviceId);
    }
    return _instance;
  }
}
export default DTMFGenerator;